










































































































import { Component, Vue } from 'vue-property-decorator';

import { TEntity } from '@/plugins/podolib/services/entities/Entity';
import { TStation } from '@/plugins/podolib/services/entities/EntityStations';

import CompositeCardV2 from '@/components/composite/CompositeCardV2.vue';
import ElementBgIcon from '@/components/elements/ElementBgIcon.vue';
import EquipmentsStationEditDialog from '@/components/equipments/EquipmentsStationEditDialog.vue';
import EquipmentsStationDetailsDialog from '@/components/equipments/EquipmentsStationDetailsDialog.vue';
import EquipmentsStationDeleteDialog from '@/components/equipments/EquipmentsStationDeleteDialog.vue';
import { Severity } from '@sentry/types';

type TSyncableTable = {
  headers: object[];
  stations: {
    list: TEntity<TStation>[];
    total: number;
  };
  options: {
    page: number;
    itemsPerPage: number;
    sortBy: string[];
    sortDesc: boolean[];
  };
  pending: boolean;
  disabled: boolean;
  error: Error | null;
};

interface IEquipmentsStations extends Vue {
  table: TSyncableTable;
  fetchStations(): void;
  patchStation(station: TEntity<TStation>): void;
}

@Component<IEquipmentsStations>({
  components: {
    EquipmentsStationDeleteDialog,
    EquipmentsStationDetailsDialog,
    EquipmentsStationEditDialog,
    ElementBgIcon,
    CompositeCardV2,
  },
  created() {
    // TODO : optimize
    this.$pdc.bus!.on('doctor:patched', this.fetchStations);
    this.$pdc.bus!.on('entities:stations:created', this.fetchStations);
    this.$pdc.bus!.on('entities:stations:patched', this.patchStation);
    this.$pdc.bus!.on('entities:stations:removed', this.fetchStations);

    this.fetchStations();
  },
  beforeDestroy() {
    // TODO : optimize
    this.$pdc.bus!.off('doctor:patched', this.fetchStations);
    this.$pdc.bus!.off('entities:stations:created', this.fetchStations);
    this.$pdc.bus!.off('entities:stations:patched', this.patchStation);
    this.$pdc.bus!.off('entities:stations:removed', this.fetchStations);
  },
})
export default class EquipmentsStations extends Vue {
  table: TSyncableTable = {
    // Values prefixed with "__" are virtuals : they are not in entity documents, they are only used
    //    to customize the table with row that have access to the entire document.
    headers: [],
    stations: {
      list: [],
      total: 0,
    },
    options: {
      page: 1,
      itemsPerPage: this.$pdc.entities!.stations.storedEntity.total,
      sortBy: ['updatedAt'],
      sortDesc: [true],
    },
    pending: false,
    disabled: false,
    error: null,
  };

  renameStation(station: TEntity<TStation>) {
    this.$pdc.bus!.emit('station:edit', station);
  }

  configureStation() {
    this.$pdc.bus!.emit('equipments:configure-kit-dialog:open');
  }

  showStationDetails(station: TEntity<TStation>) {
    this.$pdc.bus!.emit('station:details', station);
  }

  deleteStation(stationId: TEntity<TStation>['_id']) {
    this.$pdc.bus!.emit('station:delete', stationId);
  }

  async fetchStations() {
    // Avoid duplication of the process
    if (this.table.pending) return;

    try {
      // Reset 'error' flag
      this.table.error = null;
      // Set 'pending' flag
      this.table.pending = true;

      // Set query
      const query: any = {
        ...this.$pdc.entities?.stations.defaultQuery,
        $limit: this.table.options.itemsPerPage === -1 ? this.table.stations.total : this.table.options.itemsPerPage,
        $skip: this.table.options.itemsPerPage * this.table.options.page - this.table.options.itemsPerPage,
        $sort: {
          [this.table.options.sortBy[0]]: this.table.options.sortDesc[0] ? -1 : 1,
        },
      };

      // Try to retreive entities...
      const response = await this.$pdc.repository!.fetchRessource({
        ressource: 'stations',
        params: query,
      });

      this.table.stations = {
        list: response.data,
        total: response.total,
      };
    } catch (e) {
      // Set 'error' flag
      this.table.error = e;
      // Sentry
      this.$sentry.captureMessage(e.message, Severity.Error);
    } finally {
      // Reset 'pending' flag
      this.table.pending = false;
    }
  }

  async patchStation(station: TEntity<TStation>) {
    const _targetIndex = this.table.stations.list.findIndex((x) => x._id === station._id);
    if (_targetIndex >= 0) {
      this.$set(this.table.stations.list, _targetIndex, station);
    }
  }
}
